import { Tile } from "./Tile";
import { NEXTX_LINKS } from "../lib/nextxLinks";

export function ShippingDashboard() {
  return (
    <section className="grid grid-cols-1 gap-8 px-12 py-10 md:grid-cols-2 xl:grid-cols-4">
      <Tile
        label="Outstanding"
        endpoint="/api/shipping-outstanding"
        link={NEXTX_LINKS.shippingOutstanding}
        showAging={false}
      />
      <Tile
        label="Pending"
        endpoint="/api/shipping-pending"
        link={NEXTX_LINKS.shippingPending}
      />
      <Tile
        label="Returns waiting"
        endpoint="/api/shipping-returns"
        link={NEXTX_LINKS.shippingReturns}
        showAging={false}
      />
      <Tile
        label="Lifecycle pending"
        endpoint="/api/shipping-lifecycle"
        link={NEXTX_LINKS.shippingLifecycle}
      />
    </section>
  );
}
